// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1EsYC","change":"styles-module--change--2MR6I","amount":"styles-module--amount--277wI"};